import React from 'react';
import { useFormContext } from 'react-hook-form';
import i18n from '../../I18n';
import { CustomTitleLabel } from '../earning/CustomBaseComponments';
import CustomEditor from 'components/base/CustomEditor';
import CustomTitleWithInput from '../base/CustomTitleWithInput';
import './MaintenanceContent.scss';

const MaintenanceContent = ({
  language,
}) => {
  const { watch, setValue } = useFormContext();
  const titleField = `translations.${language}.title`;
  const descriptionField = `translations.${language}.description`;

  const title = watch(titleField);
  const description = watch(descriptionField);

  return (
    <>
      <div className="first-section-title">
        {i18n.t('maintenanceNotice', { locale: language })}
      </div>
      <label className="tips-message maintenance-content-tips">{i18n.t('maintenanceNoticeTips', { locale: language })}</label>
      <CustomTitleWithInput
        title={i18n.t('title', { locale: language })}
        tips={i18n.t('maintenanceTitleTips', { locale: language })}
        defaultValue={title}
        setValue={(value) => {
          setValue(titleField, value, { shouldDirty: true, });
        }}
      />
      <CustomTitleLabel
        title={i18n.t('description', { locale: language })}
      />
      <label className="tips-message">{i18n.t('maintenanceDescriptionTips', { locale: language })}</label>
      <CustomEditor
        initialValue={description}
        onValueChange={(data) => {
          setValue(descriptionField, data, { shouldDirty: true });
        }}
      />
    </>
  );
}

export default MaintenanceContent;
